import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@hooks";
import { RootState } from "@Store";
import { selectAppPolicyData, selectAppsList } from "@Store/Apps/selectors";
import { appsListRequest, getAppPolicyRequest } from "@Store/Apps/actions";
import AppPolicyTab from "@Pages/System/AppPoliciesPage/AppPolicyTab";
import "@Pages/CompanyLegal/styles.scss";
import "./styles.scss";

const AppPoliciesPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const [activeTabKey, setActiveTabKey] = useState("privacy");

  const appId = new URLSearchParams(location.search).get("appId") || "";

  const { policyData, appsList } = useAppSelector((state: RootState) => ({
    policyData: selectAppPolicyData(state),
    appsList: selectAppsList(state),
  }));

  const appName =
    appsList.find((app) => app.appId === appId)?.appName || appId;

  useEffect(() => {
    if (!appId) {
      history.replace("/system/apps");
      return;
    }
    dispatch(appsListRequest());
  }, [appId, dispatch, history]);

  useEffect(() => {
    if (appId) {
      dispatch(
        getAppPolicyRequest({
          appId,
          type: activeTabKey,
        })
      );
    }
  }, [dispatch, appId, activeTabKey]);

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: string) => {
    setActiveTabKey(newValue);
  };

  if (!appId) {
    return null;
  }

  return (
    <Box className="root">
      <div className="page-container app-policies-page">
        <h2>
          {t("apps.policies.title")} — {appName}
        </h2>
        <Tabs value={activeTabKey} onChange={handleChange}>
          <Tab label={t("sidebar.organization.privacy")} value="privacy" />
          <Tab label={t("sidebar.organization.terms")} value="gtac" />
        </Tabs>
        {activeTabKey === "privacy" && (
          <AppPolicyTab
            type="PRIVACY"
            appId={appId}
            policyData={policyData}
          />
        )}
        {activeTabKey === "gtac" && (
          <AppPolicyTab
            type="GTAC"
            appId={appId}
            policyData={policyData}
          />
        )}
      </div>
    </Box>
  );
};

export default AppPoliciesPage;
